import { Card } from "./ui/card";

interface GoogleMapProps {
  center?: {
    lat: number;
    lng: number;
  };
  zoom?: number;
  markers?: Array<{
    lat: number;
    lng: number;
    title?: string;
  }>;
  height?: string;
  className?: string;
  embedUrl?: string;
}

const GoogleMap = ({
  center,
  zoom = 13,
  height = "400px",
  className = "",
  embedUrl,
}: GoogleMapProps) => {
  // Use provided embedUrl or create one from coordinates
  const mapUrl = embedUrl || `https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=${center?.lat},${center?.lng}&zoom=${zoom}`;

  return (
    <Card className={`overflow-hidden ${className}`}>
      <div style={{ height, width: "100%" }}>
        <iframe
          width="100%"
          height="100%"
          style={{ border: 0 }}
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          src={mapUrl}
          title="Groomie Roomie location map - Denver mobile pet grooming service area"
        />
      </div>
    </Card>
  );
};

export default GoogleMap;
